import React, { type FC, type SVGProps } from 'react';

interface Props {
  label: string;
  labelIsHidden?: boolean;
  disabled?: boolean;
  placeholder?: string;
  value: string | number | null | undefined;
  onChangeValue: (newValue: string | number) => void;
  onEnterPress?: () => void;
  onFocus?: () => void;
  className?: string;
  inputContainerClassName?: string;
  type?: 'number' | 'text' | 'email';
  size?: number;
  prefix?: string;
  subtlePrefix?: string;
  postfix?: string;
  Icon?: FC<SVGProps<SVGSVGElement>>;
}

const TextInput: FC<Props> = ({
  label,
  labelIsHidden = false,
  disabled = false,
  placeholder,
  value,
  onChangeValue,
  onEnterPress,
  onFocus,
  className = '',
  inputContainerClassName = '',
  type,
  size,
  prefix,
  subtlePrefix,
  postfix,
  Icon,
}) => {
  return (
    <div className={`${className} box-border`}>
      {!labelIsHidden ? (
        <h3 className="mb-2 text-base font-normal text-leland-gray-dark">
          {label}
        </h3>
      ) : null}
      <div
        className={`flex items-center overflow-hidden rounded-lg border border-leland-gray-stroke transition duration-100 focus-within:border-leland-gray-extra-light ${inputContainerClassName}`}
      >
        {prefix ? (
          <div className="pointer-events-none whitespace-nowrap border border-transparent bg-gray-100 px-4 py-3 text-leland-gray-light">
            <span>{prefix}</span>
          </div>
        ) : null}
        {Icon ? (
          <Icon className="ml-4 size-5 text-leland-gray-extra-light" />
        ) : null}
        {subtlePrefix ? (
          <div className="pointer-events-none whitespace-nowrap border border-transparent py-3 pl-4 pr-0.5">
            <span>{subtlePrefix}</span>
          </div>
        ) : null}
        <input
          className={`block w-full bg-white py-4 shadow-none outline-none outline-0 ring-0 placeholder:text-gray-400 ${
            Icon ? 'pl-2.5 pr-4' : 'px-4'
          } ${postfix ? 'rounded-r-none' : ''} ${
            prefix ? 'rounded-l-none' : ''
          } ${subtlePrefix ? 'rounded-l-none border-l-0 pl-0' : ''} ${
            disabled
              ? 'cursor-not-allowed bg-leland-gray-hover pl-12 text-leland-gray-light'
              : ''
          }`}
          type={type}
          value={value ?? ''}
          placeholder={placeholder}
          onChange={(e) => {
            if (size != null && e.target.value.length > size) {
              return;
            }
            onChangeValue(e.target.value);
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter' && onEnterPress) {
              onEnterPress();
            }
          }}
          onFocus={onFocus}
          maxLength={size}
          disabled={disabled}
        />
        {postfix ? (
          <div className="pointer-events-none whitespace-nowrap border border-transparent bg-gray-100 p-3 text-base text-leland-gray-light">
            <span>{postfix}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default TextInput;
